import * as React from 'react';
import { NewsCommandContainer } from '../../../../commandContainer';
import { ArticleSearchBox } from '../../../../searchBox';

export const ArticleSearch = () => (
  <NewsCommandContainer>
    <ArticleSearchBox
      widthLines={['full', undefined, undefined, 30, undefined, 35]}
    />
  </NewsCommandContainer>
);
